import { render, staticRenderFns } from "./DfrReportTable.vue?vue&type=template&id=1ad7f0ca&scoped=true"
import script from "./DfrReportTable.vue?vue&type=script&lang=js"
export * from "./DfrReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad7f0ca",
  null
  
)

export default component.exports